import { render, staticRenderFns } from "./AddTableModal.vue?vue&type=template&id=97c09034&scoped=true&lang=html"
import script from "./AddTableModal.vue?vue&type=script&lang=js"
export * from "./AddTableModal.vue?vue&type=script&lang=js"
import style0 from "./AddTableModal.vue?vue&type=style&index=0&id=97c09034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c09034",
  null
  
)

export default component.exports